import $ from 'jquery';
import DOMPurify from 'dompurify';

var btnCloseAnnouncment = $('#close-announcement');
btnCloseAnnouncment.on("click", function () {
    markAnnouncementsRead();    
    $('.right-content').removeClass('show-notification');
    $('#main-menu .nav-link').removeClass('active-nav');
    $('#dashboard-menu').addClass('active-nav');
    $('body').removeClass('overflow-hidden');
});


let allAnnouncements = [];
let allOriginators = [];
let selectedOriginators = [];

function getAnnouncements() {
    if (!document.getElementById('announcement-list')) {
        return;
    }
    $.ajax({
        url: "/announcement",
        type: "GET",
        contentType: "application/json",
        success: function (data) {
            if (data && data.Announcements) {                
                allAnnouncements = data.Announcements;
                allOriginators = data.Originators || [];
                // Default: All selected (show all) if nothing selected
                if (selectedOriginators.length === 0 || selectedOriginators.length > 1) {
                    selectedOriginators = [];
                }
                renderOriginatorFilters();
                bindAnnouncementsFiltered();
            } else if (Array.isArray(data) && data.length) {
                allAnnouncements = data;
                allOriginators = [];
                selectedOriginators = [];
                bindAnnouncements(data);
            } else {
                $("#notification-status").hide();
            }
        },
        error: function (jqXHR) {
        }
    });
}
getAnnouncements();

function renderOriginatorFilters() {
    // Use larger buttons and add margin below the filter group
    var html = '<div class="btn-group mb-3" role="group" aria-label="Originator filter" style="gap: 0.75rem;">';
    // Only one can be active: All (when selectedOriginators is empty), or the selected originator
    html += '<button type="button" class="btn btn-outline-primary rounded-pill px-4 py-2 fs-6' + (selectedOriginators.length === 0 ? ' active' : '') + '" id="originator-all">All</button>';
    allOriginators.forEach(function(originator) {
        html += '<button type="button" class="btn btn-outline-primary rounded-pill px-4 py-2 fs-6' + (selectedOriginators.length === 1 && selectedOriginators[0] === originator ? ' active' : '') + '" data-originator="' + originator + '">' + originator + '</button>';
    });
    html += '</div>';
    $("#announcement-originator-filter").html(html);

    // Attach events
    $("#originator-all").off('click').on('click', function () {
        selectedOriginators = [];
        renderOriginatorFilters();
        bindAnnouncementsFiltered();
    });

    $("#announcement-originator-filter button[data-originator]").off('click').on('click', function () {
        var originator = $(this).data('originator');
        selectedOriginators = [originator];
        renderOriginatorFilters();
        bindAnnouncementsFiltered();
    });
}

function bindAnnouncementsFiltered() {
    var filtered = allAnnouncements;
    if (selectedOriginators.length === 1) {
        filtered = allAnnouncements.filter(function(a) {
            return a.Originator === selectedOriginators[0];
        });
    }
    bindAnnouncements(filtered);
}

function bindAnnouncements(data) {
    var announcementCount = 0;
    var announcementList = '';
    for (var i = 0; i <= data.length - 1; i++) {
        var bBorder = i === data.length - 1 ? "" : "border-bottom";
        announcementList += '<li class="w-100 mb-3 ' + bBorder + ' pb-3">';
        //var safeName = safeText(data[i].Name);
        if (data[i].IsAnnouncementRead === true) {
            announcementList += '<h3 class="h4 mb-2 text-truncate w-100">' + sanitizeHtml(data[i].Name) + '</h3>';
        } else {
            announcementCount++;
            announcementList += '<h3 id="notification-title" class="h4 mb-2 text-truncate w-100">' + sanitizeHtml(data[i].Name) + '</h3>';
        }
        announcementList += sanitizeHtml(getMessage(data[i]));
        announcementList += '</li>';
    }

    var html = '<div class="w-100 announcement-block alert alert-primary fade in alert-dismissible show">';         
        html += '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>';         
        html += '<span"> <i class="fal fa-bell pe-3" aria-hidden="true"></i>&nbsp;' + announcementCount + '&nbsp;items need your attention</h4> ';
        html +='</div>'  

    $("div#announcement").html(html);
    $("#announcement-count-block").html(announcementCount);

    if (announcementCount > '0') {
        $("#notification-status").html(announcementCount).show();
    }
    else {
        $("#notification-status").hide();
    }
    $("#announcement-list").html(announcementList);

}

function markAnnouncementsRead() {
    $.ajax({
        url: "/announcement/markread",
        type: "POST",
        contentType: "application/json",
        success: function (data) {            
            getAnnouncements();
        },
        error: function (jqXHR) {

        }
    });
}

var remainingMessages = [];

function getMessage(data) {    
    //look for separator '||' to break message and show more... link
    if (data.Message.indexOf('||') > -1) {
        var msg = data.Message.substring(0, data.Message.indexOf('||'));
        msg = msg + '<a href="javascript:void(0)" class="more" data-id="' + data.Id + '" data-isCA="' + data.IsClientAnnouncement + '">more...</a>';

        var remainingMsg = data.Message.substring(data.Message.indexOf('||') + 2);
        remainingMessages.push({ Id: data.Id, Message: remainingMsg, IsClientAnnouncement: data.IsClientAnnouncement.toString() });
        return msg;
    }
    return data.Message;
    //return safeText(data.Message);
}

document.addEventListener("DOMContentLoaded", function () {
    const announcements = document.querySelectorAll(".loginannouncements .announcement");

    announcements.forEach(announcement => {
        const announcementText = announcement.querySelector(".announcement-text");
        const readMoreLink = announcement.querySelector(".read-more");

        if (announcementText && readMoreLink) {
            readMoreLink.addEventListener("click", (event) => {
                event.preventDefault();
                if (readMoreLink.textContent === "Read More") {
                    readMoreLink.textContent = "Read Less";
                    announcementText.classList.remove("text-clip");
                } else {
                    readMoreLink.textContent = "Read More";
                    announcementText.classList.add("text-clip");
                }
            });

            if (announcementText.scrollHeight > announcementText.offsetHeight) {
                readMoreLink.style.display = "block";
            } else {
                readMoreLink.style.display = "none";
            }
        }
    });
});

function sanitizeHtml(html) {
    return DOMPurify.sanitize(html);
}